import { z } from 'zod/v3';

export const StreamSpecifierSchema = z.discriminatedUnion('t', [
  z.object({
    t: z.literal('manifest'),
    id: z.string(),
    entityName: z.string(),
  }),
  z.object({
    t: z.literal('graph'),
    relIdentity: z.tuple([z.number(), z.number()]),
    colIdentity: z.tuple([z.number(), z.number()]),
  }),
]);

export type StreamSpecifier = z.infer<typeof StreamSpecifierSchema>;
